(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 9133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(114);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(865);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2903);
/* harmony import */ var _silvertours_front_pages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1269);
/* eslint-disable global-require */ 


var getNewRelic = function() {
    return(// @ts-ignore
     false ? 0 : window.newrelic);
};
var Error404 = function(page) {
    var newrelic = getNewRelic();
    if (newrelic) {
        newrelic.noticeError("The requested page was not found");
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_silvertours_front_pages__WEBPACK_IMPORTED_MODULE_0__/* .LandingPageLegacy.ErrorPage */ .U.mf, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, page));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Error404);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);